"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateValidationError = exports.error = exports.success = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
exports.success = 'Successful response';
var apiResponseErrorDef = joi_1.default.array().items(joi_1.default.object({
    field: joi_1.default.string(),
    codes: joi_1.default.string()
}));
exports.error = joi_1.default.object({
    message: joi_1.default.string().default('Validation failed'),
    errors: apiResponseErrorDef
});
var generateValidationError = function () {
    return {
        code: 422,
        description: 'Validation error',
        schema: exports.error
    };
};
exports.generateValidationError = generateValidationError;
//# sourceMappingURL=api.response.def.js.map